(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    (() => {
  function isEmptyContent(node) {
    if (!node) return true;
    if (node.querySelector('img, video, svg, iframe, picture, source, object, embed')) return false;
    const text = node.textContent.replace(/\u00A0/g, ' ').trim();
    return text.length === 0;
  }

  function prune(root = document) {
    root.querySelectorAll('accordion-custom').forEach(acc => {
      const header = acc.querySelector('.details__header');
      const content = acc.querySelector('.details-content');
      if (!header || !content) return;

      const headerText = header.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      const isIngredients = headerText.includes('ingredienser') || headerText.includes('ingredients');

      if (isIngredients && isEmptyContent(content)) {
        acc.remove(); // or: acc.style.display = 'none';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => prune(document));
  // Re-run inside Theme Editor when sections/blocks reload/select
  document.addEventListener('shopify:section:load', e => prune(e.target));
  document.addEventListener('shopify:block:select', e => prune(e.target));
})();
  } catch(e) { console.error(e); }
})();

})();
